import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Divider,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { legalService, type LegalTemplate } from '../services/legalService';
import { LegalBlocks } from './legal/LegalBlocks';

interface LegalModalProps {
  open: boolean;
  onClose: () => void;
  type: 'terms' | 'privacy' | 'refund';
}

const KEY_BY_TYPE = {
  terms: 'terms-of-use',
  privacy: 'privacy-policy',
  refund: 'refund-policy',
} as const;

const LegalModal: React.FC<LegalModalProps> = ({ open, onClose, type }) => {
  const [template, setTemplate] = useState<LegalTemplate | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    setLoading(true);
    legalService
      .getTemplate(KEY_BY_TYPE[type])
      .then((data) => {
        if (!cancelled) setTemplate(data);
      })
      .catch(() => {
        if (!cancelled) setTemplate(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, type]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3, maxHeight: '90vh' } }}>
      <DialogTitle
        sx={{
          m: 0,
          p: 3,
          backgroundColor: 'primary.main',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h5" component="span" fontWeight="bold">
          {template?.title || 'Documento'}
        </Typography>
        <IconButton aria-label="fechar" onClick={onClose} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 4 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={6}>
            <CircularProgress />
          </Box>
        ) : (
          <LegalBlocks blocks={template?.blocks || []} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LegalModal;
